import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddHolidayModal from 'modules/locations/components/AddHoliday'

const AddHolidayModalPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.holidays.fullPath({ id }))
  }

  return <AddHolidayModal locationId={+id} onClose={onClose} />
}

export default AddHolidayModalPage
